import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Divider, Grid } from "@mui/material";
import { AdjustmentApplication, AdjustmentType } from "../../../MealTrack/MTAPITypes";
import { OrderSummaryLine } from "./orderSummarySubComponents";
import { DefaultCartText } from "./orderSummary-Types";
export const DiscountSummary = ({ coupon, discountSummaryTextConfigurations, showDivider = false, indent = false, }) => {
    var _a, _b, _c;
    const { mealDiscountHeader, couponHeader, surchargeHeader } = discountSummaryTextConfigurations || {};
    /**
     * If coupons are automatically applied, the coupon name will be prefixed with
     * MealDiscountTextDisplay otherwise CouponTextDisplay is applied.
     * Both of which are configurable in KMS CartSettings
     */
    const discountPrefix = coupon.automaticDiscount
        ? (_a = mealDiscountHeader === null || mealDiscountHeader === void 0 ? void 0 : mealDiscountHeader.label) !== null && _a !== void 0 ? _a : DefaultCartText.DISCOUNT
        : (_b = couponHeader === null || couponHeader === void 0 ? void 0 : couponHeader.label) !== null && _b !== void 0 ? _b : DefaultCartText.DISCOUNT;
    const couponTitle = (coupon.adjustmentType === AdjustmentType.Surcharge
        ? `${(_c = surchargeHeader === null || surchargeHeader === void 0 ? void 0 : surchargeHeader.label) !== null && _c !== void 0 ? _c : DefaultCartText.SURCHARGE}-${coupon.name}`
        : `${discountPrefix}-${coupon.name}`) +
        (coupon.type === AdjustmentApplication.Percent ? ` (${coupon.value}%)` : "");
    const couponValue = coupon.adjustmentType === AdjustmentType.Surcharge ? coupon.appliedValue : -Math.abs(coupon.appliedValue);
    return (_jsxs(React.Fragment, { children: [_jsx(OrderSummaryLine, { label: couponTitle, value: couponValue, indent: indent }), showDivider && (_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(Divider, {}) })))] }, coupon.name));
};
